// Spec 081 (FR-027) — quantidade passou a aceitar fração, e toda tela que a exibe precisa mostrar
// a fração em pt-BR. Fonte única: cópias divergiriam no número de casas, e a mesma execução
// apareceria como 415,5 numa tela e 416 na outra.
//
// Até três casas, que é a escala da coluna, e sem zeros à direita: 30 continua "30", não "30,000".

const QUANTITY_FORMAT = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
});

/** Quantidade em pt-BR, ou "—" quando não há número — nunca zero no lugar de ausência. */
export function formatQuantity(v: unknown): string {
  const n = typeof v === "number" ? v : Number(v);
  if (v === null || v === undefined || v === "" || !Number.isFinite(n)) return "—";
  return QUANTITY_FORMAT.format(n);
}
